import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const seatsIOApi = createApi({
  reducerPath: 'seatsIOApi',
  baseQuery: fetchBaseQuery({
    baseUrl: ``,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['SeatsIO'],
  endpoints: (builder) => ({
    getHoldToken: builder.query({
      query: () =>
        `${process.env.NEXT_PUBLIC_API_EVENT}/checkout-seats-query/api/v1/token?lifetime=30`,
      providesTags: ['Seats'],
    }),
    createHoldToken: builder.mutation({
      query: (minutes) => ({
        url: `api/seats-io/createHoldToken`,
        method: 'POST',
        body: {
          expiresInMinutes: minutes,
        },
      }),
    }),
    changeExpirationHoldToken: builder.mutation({
      query: (body) => ({
        url: `api/seats-io/changeExpirationHoldToken`,
        method: 'POST',
        body,
      }),
    }),
    findBestAvailable: builder.mutation({
      query: (body) => ({
        url: `api/seats-io/bestAvailable`,
        method: 'POST',
        body,
      }),
    }),
    releaseGAObjects: builder.mutation({
      query: ({ objectId, holdToken, seatsEvent, quantity }) => ({
        url: `api/seats-io/releaseObjects`,
        method: 'POST',
        body: {
          objects: [{ objectId, quantity }],
          holdToken,
          seatsEvent,
        },
      }),
    }),
  }),
});

export const {
  useGetHoldTokenQuery,
  useCreateHoldTokenMutation,
  useChangeExpirationHoldTokenMutation,
  useLazyGetHoldTokenQuery,
  useFindBestAvailableMutation,
  useReleaseGAObjectsMutation,
} = seatsIOApi;
